import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconEmail1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"email-1, envelope"} maskId="square-filled-radius-0-stroke-1-IconEmail1"><path d="M2 4.17215L12 12.354L22 4.17215V4H2V4.17215Z" fill="currentColor"/><path d="M2 5.46421V20H22V5.46421L12 13.646L2 5.46421Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconEmail1;
